import { render, staticRenderFns } from "./LanguageNotice.vue?vue&type=template&id=e5e78820&scoped=true&"
import script from "./LanguageNotice.vue?vue&type=script&lang=js&"
export * from "./LanguageNotice.vue?vue&type=script&lang=js&"
import style0 from "./LanguageNotice.vue?vue&type=style&index=0&id=e5e78820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e78820",
  null
  
)

export default component.exports